export default __webpack_public_path__ + "Icon/icons/rounded/details.svg";